import { Stack, Typography } from '@mui/material';
import { ComponentType } from 'react';

import { BoxedIcon } from '@/components/display/Ribbon/BoxedIcon';
import { IconProps } from '@/components/icons/User01Icon';

interface ReviewSuggestionSectionHeaderProps {
  description: string;
  title: string;
}

export function ReviewSuggestionSectionHeader({
  description,
  title,
}: ReviewSuggestionSectionHeaderProps) {
  return (
    <Stack spacing={0.25}>
      <Typography variant="title-s">{title}</Typography>
      <Typography variant="body-s" sx={{ color: 'text.secondary' }}>
        {description}
      </Typography>
    </Stack>
  );
}

interface ReviewSuggestionEntityGroupHeaderProps {
  backgroundColor: string;
  icon: ComponentType<IconProps>;
  iconColor: string;
  subtitle?: string;
  title: string;
}

export function ReviewSuggestionEntityGroupHeader({
  backgroundColor,
  icon,
  iconColor,
  subtitle,
  title,
}: ReviewSuggestionEntityGroupHeaderProps) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <BoxedIcon
        icon={icon}
        sx={{ backgroundColor }}
        iconProps={{ size: 24, color: iconColor, strokeWidth: 1.67 }}
      />
      <Stack spacing={0.25}>
        <Typography variant="title-s">{title}</Typography>
        {subtitle && <Typography variant="body-xs">{subtitle}</Typography>}
      </Stack>
    </Stack>
  );
}
